export default {
  zh: {
    userDetail: '用户详情',
    addUser: '新增用户',
    editUser: '编辑用户',
    searchUser: '搜索用户',
    selectTeam: '选择部门',
    ipRestrict: 'IP 限制',
    forceResetPasswordEvery: '强制重置密码每隔',
    all: '全部',
    active: '活跃',
    inactive: '禁用',
    onlineStatus: '在线状态',
    actionButtonGroup: {
      editUser: '修改用户信息',
      inactiveUser: '禁用用户',
      loginAsUser: '以此用户身份登陆'
    }
  },
  en: {
    userDetail: 'User Detail',
    addUser: 'Add User',
    editUser: 'Edit User',
    searchUser: 'Search User',
    selectTeam: 'Select Team',
    ipRestrict: 'IP Restriction',
    forceResetPasswordEvery: 'Force Reset Password Every',
    all: 'All',
    active: 'Active',
    inactive: 'Inactive',
    onlineStatus: 'Online status',
    actionButtonGroup: {
      editUser: 'Edit User',
      inactiveUser: 'Inactive User',
      loginAsUser: 'Login as User'
    }
  },
};



// WEBPACK FOOTER //
// ./src/views/Setup/Users/i18n.js